import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card/Card';
import { SectionLabel } from '@/components/ui/section-label';

type CollapsibleFormSectionProps = {
  icon: React.ReactNode;
  title: string;
  toggleLabel: string;
  countLabel: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
};

export const CollapsibleFormSection: React.FC<CollapsibleFormSectionProps> = ({
  icon,
  title,
  toggleLabel,
  countLabel,
  defaultOpen = false,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Card tier="inset" padding="none" className="mt-4">
      <button
        type="button"
        aria-expanded={open}
        aria-label={toggleLabel}
        onClick={() => setOpen((prev) => !prev)}
        className="flex w-full items-center justify-between gap-3 rounded-[inherit] px-4 py-3 text-left outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50"
      >
        <SectionLabel>
          {icon}
          {title}
        </SectionLabel>
        <span className="flex items-center gap-2">
          <Badge>{countLabel}</Badge>
          <ChevronDown
            className={cn(
              'h-4 w-4 text-muted-foreground transition-transform duration-200',
              open && 'rotate-180'
            )}
            aria-hidden
          />
        </span>
      </button>
      {open && (
        <div className="border-t border-border px-4 pb-4 pt-3">{children}</div>
      )}
    </Card>
  );
};
